var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
import { inject } from "tsyringe";
import { IdMap, IdentifiableMap, RArray, RMutableMultiSet, } from "../../collections";
import { makeImmutable, Quantity } from "../../core";
import { perRestaurant } from "../../di";
import { ModifierItemInstanceAvailabilityService } from "../AvailabilityService";
import { ExtraFeeTypes, } from "../Menu";
import { ModifierItemPackagingVariantId } from "../Identifiers";
import { ModifierInstanceCreator } from "./ModifierInstanceCreator";
import { ModifierInstanceCreatorEditability } from "./ModifierInstanceCreatorEditability";
import { ModifierItemInstanceCreator } from "./ModifierItemInstanceCreator";
let ModifierInstanceCreatorFactory = class ModifierInstanceCreatorFactory {
    constructor(modifierItemInstanceAvailabilityService, extraFeeTypes) {
        this.modifierItemInstanceAvailabilityService = modifierItemInstanceAvailabilityService;
        this.extraFeeTypes = extraFeeTypes;
        makeImmutable(this);
    }
    create(params) {
        const { modifierInstance: { modifierType, items }, modifierSettings, creatorScopeProvider, } = params;
        const editability = new ModifierInstanceCreatorEditability(modifierSettings.editable, creatorScopeProvider);
        // Build creator specs: (modifierItemType, packagingFeeType | null, defaultQuantity)
        const creatorSpecs = modifierType.itemTypes.objects.raw.flatMap((modifierItemType) => {
            var _a;
            const applicableFees = this.findApplicablePackagingFees(modifierType, modifierItemType);
            const baseDefaultQuantity = modifierSettings.defaultQuantity(modifierItemType.id);
            if (applicableFees.size <= 1) {
                return [
                    {
                        modifierItemType,
                        packagingFeeType: (_a = applicableFees.sample) !== null && _a !== void 0 ? _a : null,
                        defaultQuantity: baseDefaultQuantity,
                    },
                ];
            }
            // Multiple fees: one creator per fee, cheapest gets base default, rest get zero
            const sorted = applicableFees.objects.sorted((a, b) => a.price.cents - b.price.cents);
            return sorted.raw.map((fee, idx) => ({
                modifierItemType,
                packagingFeeType: fee,
                defaultQuantity: idx === 0 ? baseDefaultQuantity : Quantity.Zero,
            }));
        });
        // Build itemQuantities: use stored quantity when available, else use defaultQuantity
        const itemQuantities = RMutableMultiSet.fromIterable(new RArray(creatorSpecs).map(({ modifierItemType, packagingFeeType, defaultQuantity }) => {
            var _a, _b;
            const variantKey = new ModifierItemPackagingVariantId(modifierItemType.id, (_a = packagingFeeType === null || packagingFeeType === void 0 ? void 0 : packagingFeeType.id) !== null && _a !== void 0 ? _a : null);
            const storedItem = items.find(variantKey);
            const qty = (_b = storedItem === null || storedItem === void 0 ? void 0 : storedItem.quantity) !== null && _b !== void 0 ? _b : defaultQuantity;
            return [variantKey, qty];
        }));
        const itemCreators = IdentifiableMap.fromIterable("variantKey", new RArray(creatorSpecs).map(({ modifierItemType, packagingFeeType, defaultQuantity }) => {
            var _a;
            return new ModifierItemInstanceCreator({
                modifierItemInstanceAvailabilityService: this.modifierItemInstanceAvailabilityService,
                itemQuantities,
                modifierType,
                modifierItemType,
                modifierItemPackagingFeeId: (_a = packagingFeeType === null || packagingFeeType === void 0 ? void 0 : packagingFeeType.id) !== null && _a !== void 0 ? _a : null,
                defaultQuantity,
                maxDuplicatesPerItem: modifierType.maxDuplicatesPerItem,
                editability,
                creatorScopeProvider,
            });
        }));
        return new ModifierInstanceCreator({
            behaviour: modifierType.behaviour,
            editorHidden: modifierType.editorHidden,
            modifierType,
            modifierSettings,
            itemQuantities,
            itemCreators,
            editability,
        });
    }
    findApplicablePackagingFees(modifierType, modifierItemType) {
        return this.extraFeeTypes.filter((feeType) => feeType.requirements.testModifier(modifierType.id, modifierItemType.id));
    }
};
ModifierInstanceCreatorFactory = __decorate([
    perRestaurant(),
    __param(1, inject(ExtraFeeTypes)),
    __metadata("design:paramtypes", [typeof (_a = typeof ModifierItemInstanceAvailabilityService !== "undefined" && ModifierItemInstanceAvailabilityService) === "function" ? _a : Object, typeof (_b = typeof IdMap !== "undefined" && IdMap) === "function" ? _b : Object])
], ModifierInstanceCreatorFactory);
export { ModifierInstanceCreatorFactory };
